<template>
    <div class="p-8 bg-white">
        <slot />
    </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

</style>
